export default __webpack_public_path__ + "static/media/pic4.b16bb34d.jpg";